// extracted by mini-css-extract-plugin
module.exports = {"section":"Info_section__1b7ZL","stage":"Info_stage__751nn","title":"Info_title__3ZAbk","text":"Info_text__2CCQG","button":"Info_button__2jCo1","container":"Info_container__5iP8T"};